<template>
  <h4 class="modal-container-title-ui">
    <slot />
  </h4>
</template>
